import { apiClient } from "../apiClient";

export const DIEM_KY_HIEU_ENDPOINT = 'diem-ky-hieu';
export const diemKyHieuApi = {
    SelectAll: () => apiClient.get(`${DIEM_KY_HIEU_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(DIEM_KY_HIEU_ENDPOINT, payload),
    Update: (id: number, payload: any) => apiClient.put(`${DIEM_KY_HIEU_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${DIEM_KY_HIEU_ENDPOINT}/${id}`),
}